import { onReady } from '../core/dom-ready.js';
import { initMarkerModules } from '../core/marker-bootstrap.js';

onReady(() => {
  initMarkerModules();
});
